import React, { useState, useEffect } from 'react';
import { Container, Box, Typography, Card, CardContent, CircularProgress, Grid, CardActions, Button } from '@mui/material';

const Landing = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch('https://massariuscdn.com/automated_sellers.json');
                const result = await response.json();
                console.log(result)
                setData(result.sellers);
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    if (loading) {
        return (
            <Container component="main" maxWidth="lg">
                <Box
                    sx={{
                        marginTop: 8,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center"
                    }}
                >
                    <CircularProgress />
                </Box>
            </Container>
        );
    }

    return (
        <Container component="main" maxWidth="lg">
            <Box
                sx={{
                    marginTop: 2,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center"
                }}
            >
                <Grid container spacing={2}>
                    {data.map((seller, index) => (
                        <Grid item xs={12} sm={6} md={4} key={index}>
                            <Card variant="outlined" sx={{ height: '100%' }}>
                                <CardContent>
                                    <Typography variant="h6" component="div">
                                        {seller.domain.replace("www.", "")}
                                    </Typography>
                                    <Typography variant="body2">
                                        Publisher: {seller.name}
                                    </Typography>
                                    <Typography variant="body2">
                                        Seller ID: {seller.seller_id}
                                    </Typography>
                                    <Typography variant="body2">
                                        Type: {seller.seller_type}
                                    </Typography>
                                </CardContent>
                                <CardActions>
                                    <Button size="small" component="a" href={`https://${seller.domain}/ads.txt`} target="_blank" rel="noopener noreferrer">
                                        Ads.txt
                                    </Button>
                                </CardActions>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </Container>
    );
};

export default Landing;
